// Settings → Rules (global, across all routes).

import { Btn } from "../components/Primitives";
import { RouteRules } from "./RouteDetail";

interface Props { onEdit: (id: string | "new") => void; }

export function RulesScreen({ onEdit }: Props) {
  return (
    <div className="page">
      <div className="topbar">
        <span className="crumb">Settings</span>
        <span className="crumb-sep">/</span>
        <h1>Rules</h1>
        <span className="grow" />
        <Btn size="sm" ico="plus" kind="primary" onClick={() => onEdit("new")}>
          New rule
        </Btn>
      </div>
      <div className="scroll" style={{ padding: "22px 28px 60px" }}>
        <p style={{
          color: "var(--ink-2)", fontSize: 13,
          maxWidth: 540, margin: "0 0 22px",
        }}>
          Rules score every inbound deal. Positive multipliers raise the score.
          Hard filters reject deals outright.
        </p>
        <RouteRules onEdit={onEdit} />
      </div>
    </div>
  );
}
